<template>
  <div class="tag-chiclet-container">
    <TagChiclet v-for="tag in tags"
                :tag-name="tag.name"
                :tag-color="tag.color"
    />
  </div>
</template>

<script setup>
  import TagChiclet from '@/components/base-components/tags/TagChiclet.vue'

  const props = defineProps(['tags'])
</script>

<style scoped lang="scss">
  .tag-chiclet-container {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 5px;
  }
</style>
